export class CommessaSearchModel {
  client_name?: string = "";
  client_code?: string = "";
  number?: string = "";
  createdAt?: Date = undefined;
  matricola?: string = "";
  state?: string = "";
}
